"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _reactDnd = require("react-dnd");
var _ItemTypes = require("./ItemTypes");
var _react = _interopRequireWildcard(require("react"));
var DroppableCategory = function DroppableCategory(props) {
  var _useDrop = (0, _reactDnd.useDrop)(function () {
      return {
        accept: _ItemTypes.ItemTypes.OPTION,
        drop: function drop() {
          return {
            name: "category-container-".concat(props.categoryIndex)
          };
        },
        collect: function collect(monitor) {
          return {
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop()
          };
        }
      };
    }),
    _useDrop2 = (0, _slicedToArray2.default)(_useDrop, 2),
    _useDrop2$ = _useDrop2[0],
    canDrop = _useDrop2$.canDrop,
    isOver = _useDrop2$.isOver,
    drop = _useDrop2[1];
  var ref = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  (0, _react.useLayoutEffect)(function () {
    setWidth(ref.current.offsetWidth);
  }, []);
  var isActive = canDrop && isOver;
  var backgroundColor = '#f5f5f5';
  var border = 'solid 1px #bdbdbd';
  if (isActive) {
    backgroundColor = '#bdbdbd';
    border = 'solid 2px #4696eb';
  }
  var showText = true;
  for (var i = 0; i < props.stateOptions.length; ++i) {
    if (props.stateOptions[i].currentCategory === props.categoryIndex) {
      showText = false;
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    key: props.categoryIndex
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "category-container-label"
  }, /*#__PURE__*/_react.default.createElement("b", null, props.value)), /*#__PURE__*/_react.default.createElement("div", {
    id: "category-container-".concat(props.categoryIndex),
    className: "category-container" + (showText ? " sorting-center-text" : ""),
    style: {
      backgroundColor: backgroundColor,
      border: border,
      marginBottom: "12px"
    },
    ref: drop
  }, showText && /*#__PURE__*/_react.default.createElement("span", {
    style: {
      maxWidth: "".concat(width - 20, "px")
    },
    className: "empty-category-text",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("i", null, "(Drag and drop your answer choice here)")), props.childOptions));
};
var _default = exports.default = DroppableCategory;